import * as React from "react";
import { Route, Routes, Link } from "react-router-dom";
import Profile from "../pages/Profile";

import IconProfile from '../assets/ic_profile.svg';
import IconPassword from '../assets/ic_password.svg';
import IconInvoice from '../assets/ic_invoice.svg';
import IconNotification from '../assets/ic_notification.svg';
import IconStar from '../assets/ic_star.svg';
import IconLogout from '../assets/ic_logout.svg';
import Transaction from "../pages/Transaction";
import TransactionRedeem from "../pages/TransactionRedeem";
import Notification from "../pages/Notification";
import ListOutlet from "../pages/ListOutlet";
import Password from "../pages/Password";
import Review from "../pages/Review";
import UpgradePengguna from "../pages/Settings/UpgradePengguna";
import Content from "../pages/Settings/Content";
import ContentToko from "../pages/Settings/ContentToko";
import Etalase from "../pages/Settings/Etalase";
import Outlet from "../pages/Settings/Outlet";
import Promotion from "../pages/Settings/Promotion";
import Voucher from "../pages/Settings/Voucher";

import { clientSettings, executeGet, executePost } from '../functions/Kubuku';
import { LOGOUT } from '../api';
import PromotionDetail from "../pages/Settings/PromotionDetail";
import VoucherDetail from "../pages/Settings/VoucherDetail";
import LaporanTransaksi from "../pages/Settings/LaporanTransaksi";
import QRBuku from "../pages/Settings/QRBuku";
// const Home = () => <h1>Home</h1>;
// const Profiles = () => <h1>Profile</h1>;
const Settings = () => <h1>Settings</h1>;

const routes = [
    {
        path: "/",
        main: () => <Profile />,
        sidebar: () => (
            <p>
                This is your home page. You'll see your feed which is made up of the
                people you follow.
            </p>
        )
    },
    {
        path: "/transaksi",
        main: () => <Transaction />,
        sidebar: () => (
            <p>
                This is your profile page. You'll be able to see all your profile
                information as well as the people you follow.
            </p>
        )
    },
    {
        path: "/password",
        main: () => <Password />,
        sidebar: () => (
            <p>
                This is your profile page. You'll be able to see all your profile
                information as well as the people you follow.
            </p>
        )
    },
    {
        path: "/notification",
        main: () => <Notification />,
        sidebar: () => (
            <p>
                This is your settings page. You can change your name, image, and
                anything else associated with your account.
            </p>
        )
    },
    {
        path: "/outlet",
        main: () => <ListOutlet />,
        sidebar: () => (
            <p>
                This is your settings page. You can change your name, image, and
                anything else associated with your account.
            </p>
        )
    },
    {
        path: "/ulasan",
        main: () => <Review />,
        sidebar: () => (
            <p>
                This is your settings page. You can change your name, image, and
                anything else associated with your account.
            </p>
        )
    },
    {
        path: "/transaksi-redeem",
        main: () => <TransactionRedeem />,
        sidebar: () => (
            <p>
                This is your settings page. You can change your name, image, and
                anything else associated with your account.
            </p>
        )
    },
    {
        path: "/setting-content",
        main: () => <Content />,
        sidebar: () => (
            <p>
                This is your settings page. You can change your name, image, and
                anything else associated with your account.
            </p>
        )
    },
    {
        path: "/setting-content-toko",
        main: () => <ContentToko />,
        sidebar: () => (
            <p>
                This is your settings page. You can change your name, image, and
                anything else associated with your account.
            </p>
        )
    },
    {
        path: "/setting-outlet/:id/:name",
        main: () => <Outlet />,
        sidebar: () => (
            <p>
                This is your home page. You'll see your feed which is made up of the
                people you follow.
            </p>
        )
    },
    {
        path: "/setting-etalase/content/:id/",
        main: () => <Etalase />,
        sidebar: () => (
            <p>
                This is your home page. You'll see your feed which is made up of the
                people you follow.
            </p>
        )
    },
    {
        path: "/setting-promotion",
        main: () => <Promotion />,
        sidebar: () => (
            <p>
                This is your settings page. You can change your name, image, and
                anything else associated with your account.
            </p>
        )
    },
    {
        path: "/setting-promotion-detail/view/:id",
        main: () => <PromotionDetail />,
        sidebar: () => (
            <p>
                This is your settings page. You can change your name, image, and
                anything else associated with your account.
            </p>
        )
    },
    {
        path: "/setting-voucher",
        main: () => <Voucher />,
        sidebar: () => (
            <p>
                This is your settings page. You can change your name, image, and
                anything else associated with your account.
            </p>
        )
    },
    {
        path: "/setting-voucher-detail/view/:id",
        main: () => <VoucherDetail />,
        sidebar: () => (
            <p>
                This is your settings page. You can change your name, image, and
                anything else associated with your account.
            </p>
        )
    },
    {
        path: "/setting-qrbuku",
        main: () => <QRBuku />,
        sidebar: () => (
            <p>
                This is your settings page. You can change your name, image, and
                anything else associated with your account.
            </p>
        )
    }
    ,
    {
        path: "/setting-upgrade-pengguna",
        main: () => <UpgradePengguna />,
        sidebar: () => (
            <p>
                This is your settings page. You can change your name, image, and
                anything else associated with your account.
            </p>
        )
    },
    {
        path: "/setting-voucher-laporan-transaksi",
        main: () => <LaporanTransaksi />,
        sidebar: () => (
            <p>
                This is your settings page. You can change your name, image, and
                anything else associated with your account.
            </p>
        )
    }
];

const logout = async () => {
    console.log("Logout");
    try {
        const json = await executeGet(LOGOUT);
        console.log("logout = " + JSON.stringify(json));
        if (json.code == 200) {
            //localStorage.clear();
            window.localStorage.removeItem('token');
            window.localStorage.removeItem('flagOpen');
            window.location.href = window.location.origin;// + "/login";
        }
    } catch (error) {
        //console.log(error);
        this.setState({ isError: true, errorMessage: "Network Error!" });
    }
}

export default function Sidebar() {
    let admin_toko = localStorage.getItem('admin_toko');
    let flagShowRole = false;
    console.log(admin_toko);
    if (admin_toko == "1") {
        flagShowRole = true
        console.log("role = " + flagShowRole)
    }
    if (!localStorage.getItem("token")) {
        window.location.href = window.location.origin + "/login";
    }
    return (
        <div>
            <div className="pt-32 px-2 lg:px-8 xl:px-28 dark:bg-white hidden lg:block">
                <div className="flex pb-[50px] space-x-7">
                    <div className="w-3/12 hidden lg:block">
                        <div className="border rounded-2xl p-[15px] mb-[30px]">
                            <aside className="w-64" aria-label="Sidebar">
                                <div className="overflow-y-auto pr-5 bg-white rounded dark:bg-white">
                                    <ul className="space-y-2">
                                        <li className="active">
                                            <a href="/profile/" className="flex items-center p-2 pl-3 text-base font-normal text-gray-900 rounded-lg dark:text-gray-900 hover:bg-gray-100 dark:hover:bg-gray-100">
                                                <img className='w-4' src={IconProfile} alt="" />
                                                <span className="ml-3">Profile</span>
                                            </a>
                                        </li>
                                        <li className="active">
                                            <a href="/profile/password" className="flex items-center p-2 pl-3 text-base font-normal text-gray-900 rounded-lg dark:text-gray-900 hover:bg-gray-100 dark:hover:bg-gray-100">
                                                <img className='w-4' src={IconPassword} alt="" />
                                                <span className="ml-3">Update Password</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="/profile/transaksi" className="flex items-center p-2 pl-3 text-base font-normal text-gray-900 rounded-lg dark:text-gray-900 hover:bg-gray-100 dark:hover:bg-gray-100">
                                                <img className='w-5' src={IconInvoice} alt="" />
                                                <span className="ml-3">Daftar Transaksi</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="/profile/notification" className="flex items-center p-2 pl-3 text-base font-normal text-gray-900 rounded-lg dark:text-gray-900 hover:bg-gray-100 dark:hover:bg-gray-100">
                                                <img className='w-5' src={IconNotification} alt="" />
                                                <span className="flex-1 ml-3 whitespace-nowrap">Notification</span>
                                            </a>
                                        </li>
                                        {/*
                                        <li className="active">
                                            <a href="/profile/outlet" className="flex items-center p-2 pl-3 text-base font-normal text-gray-900 rounded-lg dark:text-gray-900 hover:bg-gray-100 dark:hover:bg-gray-100">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M5.06107 20.0451L5.50191 19.4383L5.06107 20.0451ZM3.95491 18.9389L4.56168 18.4981L3.95491 18.9389ZM20.0451 18.9389L19.4383 18.4981L20.0451 18.9389ZM18.9389 20.0451L18.4981 19.4383L18.9389 20.0451ZM18.9389 3.95491L18.4981 4.56168L18.9389 3.95491ZM20.0451 5.06107L19.4383 5.50191L20.0451 5.06107ZM5.06107 3.95491L5.50191 4.56168L5.06107 3.95491ZM3.95491 5.06107L4.56168 5.50191L3.95491 5.06107ZM16.75 11C16.75 10.5858 16.4142 10.25 16 10.25C15.5858 10.25 15.25 10.5858 15.25 11H16.75ZM15.25 17C15.25 17.4142 15.5858 17.75 16 17.75C16.4142 17.75 16.75 17.4142 16.75 17H15.25ZM12.75 7C12.75 6.58579 12.4142 6.25 12 6.25C11.5858 6.25 11.25 6.58579 11.25 7H12.75ZM11.25 17C11.25 17.4142 11.5858 17.75 12 17.75C12.4142 17.75 12.75 17.4142 12.75 17H11.25ZM8.75 13C8.75 12.5858 8.41421 12.25 8 12.25C7.58579 12.25 7.25 12.5858 7.25 13H8.75ZM7.25 17C7.25 17.4142 7.58579 17.75 8 17.75C8.41421 17.75 8.75 17.4142 8.75 17H7.25ZM12 20.25C10.1084 20.25 8.74999 20.249 7.69804 20.135C6.66013 20.0225 6.00992 19.8074 5.50191 19.4383L4.62023 20.6518C5.42656 21.2377 6.37094 21.5 7.53648 21.6263C8.68798 21.751 10.1418 21.75 12 21.75V20.25ZM2.25 12C2.25 13.8582 2.24897 15.312 2.37373 16.4635C2.50001 17.6291 2.76232 18.5734 3.34815 19.3798L4.56168 18.4981C4.19259 17.9901 3.97745 17.3399 3.865 16.302C3.75103 15.25 3.75 13.8916 3.75 12H2.25ZM5.50191 19.4383C5.14111 19.1762 4.82382 18.8589 4.56168 18.4981L3.34815 19.3798C3.70281 19.8679 4.13209 20.2972 4.62023 20.6518L5.50191 19.4383ZM20.25 12C20.25 13.8916 20.249 15.25 20.135 16.302C20.0225 17.3399 19.8074 17.9901 19.4383 18.4981L20.6518 19.3798C21.2377 18.5734 21.5 17.6291 21.6263 16.4635C21.751 15.312 21.75 13.8582 21.75 12H20.25ZM12 21.75C13.8582 21.75 15.312 21.751 16.4635 21.6263C17.6291 21.5 18.5734 21.2377 19.3798 20.6518L18.4981 19.4383C17.9901 19.8074 17.3399 20.0225 16.302 20.135C15.25 20.249 13.8916 20.25 12 20.25V21.75ZM19.4383 18.4981C19.1762 18.8589 18.8589 19.1762 18.4981 19.4383L19.3798 20.6518C19.8679 20.2972 20.2972 19.8679 20.6518 19.3798L19.4383 18.4981ZM12 3.75C13.8916 3.75 15.25 3.75103 16.302 3.865C17.3399 3.97745 17.9901 4.19259 18.4981 4.56168L19.3798 3.34815C18.5734 2.76232 17.6291 2.50001 16.4635 2.37373C15.312 2.24897 13.8582 2.25 12 2.25V3.75ZM21.75 12C21.75 10.1418 21.751 8.68798 21.6263 7.53648C21.5 6.37094 21.2377 5.42656 20.6518 4.62023L19.4383 5.50191C19.8074 6.00992 20.0225 6.66013 20.135 7.69804C20.249 8.74999 20.25 10.1084 20.25 12H21.75ZM18.4981 4.56168C18.8589 4.82382 19.1762 5.14111 19.4383 5.50191L20.6518 4.62023C20.2972 4.13209 19.8679 3.70281 19.3798 3.34815L18.4981 4.56168ZM12 2.25C10.1418 2.25 8.68798 2.24897 7.53648 2.37373C6.37094 2.50001 5.42656 2.76232 4.62023 3.34815L5.50191 4.56168C6.00992 4.19259 6.66013 3.97745 7.69804 3.865C8.74999 3.75103 10.1084 3.75 12 3.75V2.25ZM3.75 12C3.75 10.1084 3.75103 8.74999 3.865 7.69804C3.97745 6.66013 4.19259 6.00992 4.56168 5.50191L3.34815 4.62023C2.76232 5.42656 2.50001 6.37094 2.37373 7.53648C2.24897 8.68798 2.25 10.1418 2.25 12H3.75ZM4.62023 3.34815C4.13209 3.70281 3.70281 4.13209 3.34815 4.62023L4.56168 5.50191C4.82382 5.14111 5.14111 4.82382 5.50191 4.56168L4.62023 3.34815ZM15.25 11V17H16.75V11H15.25ZM11.25 7V17H12.75V7H11.25ZM7.25 13V17H8.75V13H7.25Z" fill="#414141" />
                                                </svg>

                                                <span className="ml-3">Outlet</span>
                                            </a>
                                        </li>
                                         <li>
                                            <a href="/profile/ulasan" className="flex items-center p-2 pl-3 text-base font-normal text-gray-900 rounded-lg dark:text-gray-900 hover:bg-gray-100 dark:hover:bg-gray-100">
                                                <img className='w-5' src={IconStar} alt="" />
                                                <span className="flex-1 ml-3 whitespace-nowrap">Ulasan</span>
                                            </a>
                                        </li> */}
                                        
                                    </ul>
                                </div>

                            </aside>
                        </div>
                        {
                            flagShowRole &&
                            <div className="border rounded-2xl p-[15px] mb-[30px]">
                                <aside className="w-64" aria-label="Sidebar">
                                    <div className="overflow-y-auto pr-5 bg-white rounded dark:bg-white">
                                        <ul className="space-y-3">
                                            <li className="active">
                                                <a href="/profile/setting-content-toko" className="flex items-center p-2 pl-3 text-base font-normal text-gray-900 rounded-lg dark:text-gray-900 hover:bg-gray-100 dark:hover:bg-gray-100">
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M5.25 14.25h13.5m-13.5 0a3 3 0 01-3-3m3 3a3 3 0 100 6h13.5a3 3 0 100-6m-16.5-3a3 3 0 013-3h13.5a3 3 0 013 3m-19.5 0a4.5 4.5 0 01.9-2.7L5.737 5.1a3.375 3.375 0 012.7-1.35h7.126c1.062 0 2.062.5 2.7 1.35l2.587 3.45a4.5 4.5 0 01.9 2.7m0 0a3 3 0 01-3 3m0 3h.008v.008h-.008v-.008zm0-6h.008v.008h-.008v-.008zm-3 6h.008v.008h-.008v-.008zm0-6h.008v.008h-.008v-.008z" />
                                                </svg>
                                                <span className="ml-3">Pengaturan Konten</span>
                                                </a>
                                            </li>
                                            <li className="active">
                                                <a href="/profile/setting-content" className="flex items-center p-2 pl-3 text-base font-normal text-gray-900 rounded-lg dark:text-gray-900 hover:bg-gray-100 dark:hover:bg-gray-100">
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M5.06107 20.0451L5.50191 19.4383L5.06107 20.0451ZM3.95491 18.9389L4.56168 18.4981L3.95491 18.9389ZM20.0451 18.9389L19.4383 18.4981L20.0451 18.9389ZM18.9389 20.0451L18.4981 19.4383L18.9389 20.0451ZM18.9389 3.95491L18.4981 4.56168L18.9389 3.95491ZM20.0451 5.06107L19.4383 5.50191L20.0451 5.06107ZM5.06107 3.95491L5.50191 4.56168L5.06107 3.95491ZM3.95491 5.06107L4.56168 5.50191L3.95491 5.06107ZM16.75 11C16.75 10.5858 16.4142 10.25 16 10.25C15.5858 10.25 15.25 10.5858 15.25 11H16.75ZM15.25 17C15.25 17.4142 15.5858 17.75 16 17.75C16.4142 17.75 16.75 17.4142 16.75 17H15.25ZM12.75 7C12.75 6.58579 12.4142 6.25 12 6.25C11.5858 6.25 11.25 6.58579 11.25 7H12.75ZM11.25 17C11.25 17.4142 11.5858 17.75 12 17.75C12.4142 17.75 12.75 17.4142 12.75 17H11.25ZM8.75 13C8.75 12.5858 8.41421 12.25 8 12.25C7.58579 12.25 7.25 12.5858 7.25 13H8.75ZM7.25 17C7.25 17.4142 7.58579 17.75 8 17.75C8.41421 17.75 8.75 17.4142 8.75 17H7.25ZM12 20.25C10.1084 20.25 8.74999 20.249 7.69804 20.135C6.66013 20.0225 6.00992 19.8074 5.50191 19.4383L4.62023 20.6518C5.42656 21.2377 6.37094 21.5 7.53648 21.6263C8.68798 21.751 10.1418 21.75 12 21.75V20.25ZM2.25 12C2.25 13.8582 2.24897 15.312 2.37373 16.4635C2.50001 17.6291 2.76232 18.5734 3.34815 19.3798L4.56168 18.4981C4.19259 17.9901 3.97745 17.3399 3.865 16.302C3.75103 15.25 3.75 13.8916 3.75 12H2.25ZM5.50191 19.4383C5.14111 19.1762 4.82382 18.8589 4.56168 18.4981L3.34815 19.3798C3.70281 19.8679 4.13209 20.2972 4.62023 20.6518L5.50191 19.4383ZM20.25 12C20.25 13.8916 20.249 15.25 20.135 16.302C20.0225 17.3399 19.8074 17.9901 19.4383 18.4981L20.6518 19.3798C21.2377 18.5734 21.5 17.6291 21.6263 16.4635C21.751 15.312 21.75 13.8582 21.75 12H20.25ZM12 21.75C13.8582 21.75 15.312 21.751 16.4635 21.6263C17.6291 21.5 18.5734 21.2377 19.3798 20.6518L18.4981 19.4383C17.9901 19.8074 17.3399 20.0225 16.302 20.135C15.25 20.249 13.8916 20.25 12 20.25V21.75ZM19.4383 18.4981C19.1762 18.8589 18.8589 19.1762 18.4981 19.4383L19.3798 20.6518C19.8679 20.2972 20.2972 19.8679 20.6518 19.3798L19.4383 18.4981ZM12 3.75C13.8916 3.75 15.25 3.75103 16.302 3.865C17.3399 3.97745 17.9901 4.19259 18.4981 4.56168L19.3798 3.34815C18.5734 2.76232 17.6291 2.50001 16.4635 2.37373C15.312 2.24897 13.8582 2.25 12 2.25V3.75ZM21.75 12C21.75 10.1418 21.751 8.68798 21.6263 7.53648C21.5 6.37094 21.2377 5.42656 20.6518 4.62023L19.4383 5.50191C19.8074 6.00992 20.0225 6.66013 20.135 7.69804C20.249 8.74999 20.25 10.1084 20.25 12H21.75ZM18.4981 4.56168C18.8589 4.82382 19.1762 5.14111 19.4383 5.50191L20.6518 4.62023C20.2972 4.13209 19.8679 3.70281 19.3798 3.34815L18.4981 4.56168ZM12 2.25C10.1418 2.25 8.68798 2.24897 7.53648 2.37373C6.37094 2.50001 5.42656 2.76232 4.62023 3.34815L5.50191 4.56168C6.00992 4.19259 6.66013 3.97745 7.69804 3.865C8.74999 3.75103 10.1084 3.75 12 3.75V2.25ZM3.75 12C3.75 10.1084 3.75103 8.74999 3.865 7.69804C3.97745 6.66013 4.19259 6.00992 4.56168 5.50191L3.34815 4.62023C2.76232 5.42656 2.50001 6.37094 2.37373 7.53648C2.24897 8.68798 2.25 10.1418 2.25 12H3.75ZM4.62023 3.34815C4.13209 3.70281 3.70281 4.13209 3.34815 4.62023L4.56168 5.50191C4.82382 5.14111 5.14111 4.82382 5.50191 4.56168L4.62023 3.34815ZM15.25 11V17H16.75V11H15.25ZM11.25 7V17H12.75V7H11.25ZM7.25 13V17H8.75V13H7.25Z" fill="#414141" />
                                                    </svg>

                                                    <span className="ml-3">Pengaturan Outlet</span>
                                                </a>
                                            </li>
                                            
                                            <li>
                                                <a href="/profile/setting-voucher" className="flex items-center p-2 pl-3 text-base font-normal text-gray-900 rounded-lg dark:text-gray-900 hover:bg-gray-100 dark:hover:bg-gray-100">
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M8 4L8 20" stroke="#414141" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="2 3" />
                                                        <path d="M2 8.44444C2 5.98985 3.98985 4 6.44444 4H17.5556C20.0102 4 22 5.98985 22 8.44444C22 8.98773 21.6884 9.48288 21.1986 9.71798L20.7113 9.95192C18.993 10.7767 18.993 13.2233 20.7113 14.0481L21.1986 14.282C21.6884 14.5171 22 15.0123 22 15.5556C22 18.0102 20.0102 20 17.5556 20H6.44444C3.98985 20 2 18.0102 2 15.5556C2 15.0123 2.31157 14.5171 2.80135 14.282L3.28872 14.0481C5.00702 13.2233 5.00702 10.7767 3.28872 9.95192L2.80135 9.71798C2.31157 9.48288 2 8.98773 2 8.44444Z" stroke="#414141" strokeWidth="1.5" />
                                                        <path d="M13.0175 9.73737C13.3268 8.75421 14.6732 8.75421 14.9825 9.73737C15.1208 10.177 15.5174 10.4747 15.965 10.4747C16.9657 10.4747 17.3818 11.7976 16.5722 12.4052C16.2101 12.6769 16.0586 13.1586 16.1969 13.5983C16.5062 14.5814 15.4168 15.399 14.6072 14.7914C14.2451 14.5196 13.7549 14.5196 13.3928 14.7914C12.5832 15.399 11.4938 14.5814 11.8031 13.5983C11.9414 13.1586 11.7899 12.6769 11.4278 12.4052C10.6182 11.7976 11.0343 10.4747 12.035 10.4747C12.4826 10.4747 12.8792 10.177 13.0175 9.73737Z" stroke="#414141" strokeWidth="1.5" />
                                                    </svg>

                                                    <span className="ml-3">Pengaturan Voucher</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/profile/setting-promotion" className="flex items-center p-2 pl-3 text-base font-normal text-gray-900 rounded-lg dark:text-gray-900 hover:bg-gray-100 dark:hover:bg-gray-100">
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fillRule="evenodd" clipRule="evenodd" d="M20.0848 16.9323C20.5298 12.6556 20.5298 8.34432 20.0848 4.06762C19.9261 2.54257 18.1678 1.77006 16.9372 2.68478L12.8336 5.73519C11.5831 6.6647 10.0665 7.16665 8.5084 7.16665H4.6792C3.98884 7.16665 3.4292 7.72629 3.4292 8.41664V12.5833C3.4292 13.2737 3.98884 13.8333 4.6792 13.8333H5.30348L4.45812 16.9882C4.36392 17.3398 4.53573 17.7082 4.86559 17.8621L8.54674 19.5787C8.74766 19.6724 8.97974 19.6724 9.18067 19.5787C9.3816 19.485 9.53078 19.3072 9.58815 19.093L10.8508 14.3806C10.8643 14.3306 10.8723 14.2803 10.8753 14.2305C11.5727 14.4714 12.2338 14.8189 12.8336 15.2648L16.9372 18.3152C18.1677 19.2299 19.9261 18.4574 20.0848 16.9323ZM18.5928 4.22285C19.0271 8.39634 19.0271 12.6036 18.5928 16.7771C18.5545 17.1457 18.1295 17.3324 17.8321 17.1114L13.7284 14.0609C12.2193 12.9391 10.3888 12.3333 8.50839 12.3333L4.9292 12.3333L4.9292 8.66665H8.5084C10.3888 8.66665 12.2193 8.06085 13.7284 6.93902L17.8321 3.88861C18.1295 3.66752 18.5545 3.85424 18.5928 4.22285ZM9.43615 13.8929C9.12975 13.8534 8.8199 13.8333 8.50839 13.8333H6.85639L6.06989 16.7686L8.3706 17.8415L9.40196 13.9924C9.41118 13.958 9.42264 13.9248 9.43615 13.8929Z" fill="#414141" />
                                                    </svg>

                                                    <span className="ml-3">Promo</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/profile/setting-qrbuku" className="flex items-center p-2 pl-3 text-base font-normal text-gray-900 rounded-lg dark:text-gray-900 hover:bg-gray-100 dark:hover:bg-gray-100">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z" />
                                                    </svg>
                                                    <span className="ml-3">QR Buku</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/profile/setting-upgrade-pengguna" className="flex items-center p-2 pl-3 text-base font-normal text-gray-900 rounded-lg dark:text-gray-900 hover:bg-gray-100 dark:hover:bg-gray-100">
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                                        <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
                                                    </svg>
                                                    <span className="ml-3">Upgrade Pengguna</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/profile/setting-voucher-laporan-transaksi" className="flex items-center p-2 pl-3 text-base font-normal text-gray-900 rounded-lg dark:text-gray-900 hover:bg-gray-100 dark:hover:bg-gray-100">
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M5.06107 20.0451L5.50191 19.4383L5.06107 20.0451ZM3.95491 18.9389L4.56168 18.4981L3.95491 18.9389ZM20.0451 18.9389L19.4383 18.4981L20.0451 18.9389ZM18.9389 20.0451L18.4981 19.4383L18.9389 20.0451ZM18.9389 3.95491L18.4981 4.56168L18.9389 3.95491ZM20.0451 5.06107L19.4383 5.50191L20.0451 5.06107ZM5.06107 3.95491L5.50191 4.56168L5.06107 3.95491ZM3.95491 5.06107L4.56168 5.50191L3.95491 5.06107ZM6.32665 14.5268C6.14423 14.8987 6.29782 15.3481 6.6697 15.5305C7.04158 15.7129 7.49093 15.5593 7.67335 15.1874L6.32665 14.5268ZM8.46033 11.8801L9.13368 12.2104L8.46033 11.8801ZM15.5397 12.1199L16.213 12.4502L15.5397 12.1199ZM17.6734 9.47316C17.8558 9.10127 17.7022 8.65192 17.3303 8.46951C16.9584 8.28709 16.5091 8.44068 16.3266 8.81256L17.6734 9.47316ZM12 12L11.3058 12.284L12 12ZM12 20.25C10.1084 20.25 8.74999 20.249 7.69804 20.135C6.66013 20.0225 6.00992 19.8074 5.50191 19.4383L4.62023 20.6518C5.42656 21.2377 6.37094 21.5 7.53648 21.6263C8.68798 21.751 10.1418 21.75 12 21.75V20.25ZM2.25 12C2.25 13.8582 2.24897 15.312 2.37373 16.4635C2.50001 17.6291 2.76232 18.5734 3.34815 19.3798L4.56168 18.4981C4.19259 17.9901 3.97745 17.3399 3.865 16.302C3.75103 15.25 3.75 13.8916 3.75 12H2.25ZM5.50191 19.4383C5.14111 19.1762 4.82382 18.8589 4.56168 18.4981L3.34815 19.3798C3.70281 19.8679 4.13209 20.2972 4.62023 20.6518L5.50191 19.4383ZM20.25 12C20.25 13.8916 20.249 15.25 20.135 16.302C20.0225 17.3399 19.8074 17.9901 19.4383 18.4981L20.6518 19.3798C21.2377 18.5734 21.5 17.6291 21.6263 16.4635C21.751 15.312 21.75 13.8582 21.75 12H20.25ZM12 21.75C13.8582 21.75 15.312 21.751 16.4635 21.6263C17.6291 21.5 18.5734 21.2377 19.3798 20.6518L18.4981 19.4383C17.9901 19.8074 17.3399 20.0225 16.302 20.135C15.25 20.249 13.8916 20.25 12 20.25V21.75ZM19.4383 18.4981C19.1762 18.8589 18.8589 19.1762 18.4981 19.4383L19.3798 20.6518C19.8679 20.2972 20.2972 19.8679 20.6518 19.3798L19.4383 18.4981ZM12 3.75C13.8916 3.75 15.25 3.75103 16.302 3.865C17.3399 3.97745 17.9901 4.19259 18.4981 4.56168L19.3798 3.34815C18.5734 2.76232 17.6291 2.50001 16.4635 2.37373C15.312 2.24897 13.8582 2.25 12 2.25V3.75ZM21.75 12C21.75 10.1418 21.751 8.68798 21.6263 7.53648C21.5 6.37094 21.2377 5.42656 20.6518 4.62023L19.4383 5.50191C19.8074 6.00992 20.0225 6.66013 20.135 7.69804C20.249 8.74999 20.25 10.1084 20.25 12H21.75ZM18.4981 4.56168C18.8589 4.82382 19.1762 5.14111 19.4383 5.50191L20.6518 4.62023C20.2972 4.13209 19.8679 3.70281 19.3798 3.34815L18.4981 4.56168ZM12 2.25C10.1418 2.25 8.68798 2.24897 7.53648 2.37373C6.37094 2.50001 5.42656 2.76232 4.62023 3.34815L5.50191 4.56168C6.00992 4.19259 6.66013 3.97745 7.69804 3.865C8.74999 3.75103 10.1084 3.75 12 3.75V2.25ZM3.75 12C3.75 10.1084 3.75103 8.74999 3.865 7.69804C3.97745 6.66013 4.19259 6.00992 4.56168 5.50191L3.34815 4.62023C2.76232 5.42656 2.50001 6.37094 2.37373 7.53648C2.24897 8.68798 2.25 10.1418 2.25 12H3.75ZM4.62023 3.34815C4.13209 3.70281 3.70281 4.13209 3.34815 4.62023L4.56168 5.50191C4.82382 5.14111 5.14111 4.82382 5.50191 4.56168L4.62023 3.34815ZM7.67335 15.1874L9.13368 12.2104L7.78698 11.5498L6.32665 14.5268L7.67335 15.1874ZM16.213 12.4502L17.6734 9.47316L16.3266 8.81256L14.8663 11.7896L16.213 12.4502ZM11.3058 12.284C12.185 14.433 15.1904 14.5348 16.213 12.4502L14.8663 11.7896C14.4137 12.7124 13.0833 12.6673 12.6942 11.716L11.3058 12.284ZM9.13368 12.2104C9.58632 11.2876 10.9167 11.3327 11.3058 12.284L12.6942 11.716C11.815 9.56698 8.80955 9.46517 7.78698 11.5498L9.13368 12.2104Z" fill="#414141" />
                                                    </svg>

                                                    <span className="flex-1 ml-3 whitespace-nowrap">Laporan</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </aside>
                            </div>
                        }
                        <div className="border rounded-2xl p-[15px] mb-[30px]">
                            <aside className="w-64" aria-label="Sidebar">
                                <div className="overflow-y-auto pr-5 bg-white rounded dark:bg-white">
                                    <ul className="space-y-2">
                                        
                                        <li>
                                            <a onClick={logout} className="cursor-pointer flex items-center p-2 pl-3 text-base font-normal text-gray-900 rounded-lg dark:text-gray-900 hover:bg-gray-100 dark:hover:bg-gray-100">
                                                <img className='w-5' src={IconLogout} alt="" />
                                                <span className="flex-1 ml-3 whitespace-nowrap">Logout</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>

                            </aside>
                        </div>
                    </div>
                    {console.log(routes)}
                    <div className="w-9/12 h-[75%] hidden lg:block">
                        <Routes>
                            {routes.map(({ path, main }) => (
                                <Route key={path} path={path} element={main()} />
                            ))}
                        </Routes>
                    </div>

                    <div className="w-full h-[75%] block lg:hidden">
                        <Routes>
                            {routes.map(({ path, main }) => (
                                <Route key={path} path={path} element={main()} />
                            ))}
                        </Routes>
                    </div>

                </div>

            </div>

            <div className="pt-[72px] lg:pt-28 px-4 dark:bg-white block lg:hidden">
                <div className="w-full h-[75%] block lg:hidden">
                    <Routes>
                        {routes.map(({ path, main }) => (
                            <Route key={path} path={path} element={main()} />
                        ))}
                    </Routes>
                    
                </div>

            </div>
        </div>
       

    );
}
